import React from 'react';
import { Icon } from '../../Icon/Icon';

interface ToggleIconProps {
    id: string;
    name: string;
    checked: boolean;
    checkedIcon: string;
    uncheckedIcon: string;
    disabled?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>, id: string) => void;
}

export const ToggleIcon = (props: ToggleIconProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e, props.id);
    };

    return (
        <>
            <input
                type="checkbox"
                className="custom-control-input svg-toggle-input"
                disabled={props.disabled}
                onChange={handleChange}
                name={props.name}
                checked={props.checked}
                id={'icon-toggle-' + props.id}
            />
            <label htmlFor={'icon-toggle-' + props.id} className="layer-control__svg-toggle-label">
                <Icon symbol={props.checked ? props.checkedIcon : props.uncheckedIcon} />
            </label>
        </>
    );
};
